interface ScaleSliderProps {
  min: number;
  max: number;
  value: number;
  minLabel: string;
  maxLabel: string;
  onChange: (value: number) => void;
}

export default function ScaleSlider({ min, max, value, minLabel, maxLabel, onChange }: ScaleSliderProps) {
  const steps = Array.from({ length: max - min + 1 }, (_, i) => min + i);

  return (
    <div className="w-full">
      <div className="flex items-center justify-center mb-4">
        <span className="text-3xl font-bold text-coral">{value}</span>
      </div>

      <input
        type="range"
        min={min}
        max={max}
        step={1}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full mb-3"
      />

      <div className="flex justify-between px-1">
        {steps.map((step) => (
          <div
            key={step}
            className="flex flex-col items-center gap-1"
          >
            <button
              type="button"
              onClick={() => onChange(step)}
              className={`w-7 h-7 rounded-full text-xs font-semibold transition-all duration-200 cursor-pointer ${
                value === step
                  ? 'bg-coral text-white'
                  : 'bg-white border border-border-color text-text-secondary hover:border-coral/40'
              }`}
            >
              {step}
            </button>
          </div>
        ))}
      </div>

      <div className="flex justify-between mt-2">
        <span className="text-xs text-text-secondary">{minLabel}</span>
        <span className="text-xs text-text-secondary">{maxLabel}</span>
      </div>
    </div>
  );
}